/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/no-useless-constructor */
/* eslint-disable  @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-extraneous-class */
/* eslint-disable @typescript-eslint/no-empty-object-type */
import { z } from 'zod';
import { validate } from '../../error/validate';
import { enumSchema, domainWsIntervalTypeSchema, type DomainWsIntervalType, localDatetimeSchema, type DomainWsVariantObject, type DomainWsVariantAvailability, type DomainJsonObject, type DomainWspdclasttrans, type DomainWscommitid, } from '../../schema';
import { type WebResponseResult, ValidationError } from '@pdcfrontendui/staffplan';
import { WebRequest } from './WebRequest';
import { PlanEnum, AttendanceClockInOutEnum, TimeAttendanceDeviationEnum, WsAttendanceQueryTypeEnum, TimeAttendanceRefTypeEnum, WsTimeRegEventTypeEnum, WebSimpleTypeEnum, WebMetaTypeEnum, LogonTypeEnum, SupporterLogonIdFieldEnum, UseDateTimeTypeEnum, DimensionEnumEnum, PlanSchema, AttendanceClockInOutSchema, TimeAttendanceDeviationSchema, WsAttendanceQueryTypeSchema, TimeAttendanceRefTypeSchema, WsTimeRegEventTypeSchema, WebSimpleTypeSchema, WebMetaTypeSchema, LogonTypeSchema, SupporterLogonIdFieldSchema, UseDateTimeTypeSchema, DimensionEnumSchema, PlanJsonSchema, AttendanceClockInOutJsonSchema, TimeAttendanceDeviationJsonSchema, WsAttendanceQueryTypeJsonSchema, TimeAttendanceRefTypeJsonSchema, WsTimeRegEventTypeJsonSchema, WebSimpleTypeJsonSchema, WebMetaTypeJsonSchema, LogonTypeJsonSchema, SupporterLogonIdFieldJsonSchema, UseDateTimeTypeJsonSchema, DimensionEnumJsonSchema } from './enumLib_api';
export const webTypeViewFieldSchema = z.object({
	fieldName: z.string(),
	label: z.string(),
	shortLabel: z.string(),
	webSimpleType: WebSimpleTypeSchema,
	webMetaType: WebMetaTypeSchema,
	typeName: z.string().optional().nullable().default(null),
	length: z.int().optional().nullable().default(null),
	recordType: z.any().optional().nullable().default(null),
	webConfig: z.string().optional().nullable().default(null)
});

export const webTypeViewFieldJsonSchema = z.object({
	fieldName: z.string(),
	label: z.string(),
	shortLabel: z.string(),
	webSimpleType: WebSimpleTypeJsonSchema,
	webMetaType: WebMetaTypeJsonSchema,
	typeName: z.string().optional().nullable().default(null).describe("some metatypes has a name objectlist, enum,.... for minutoffset and dataoffset the name are either start or end, for datetime it's empty"),
	length: z.int().optional().nullable().default(null).describe("some metatypes has a parameter length/precision. text : length, real : precision, dateoffset/minutoffset/datetime : 8/12/17 number of used digits in YYYYMMDDHHMISSQQQ"),
	recordType: z.any().optional().nullable().default(null).describe("types: field order equals representation order"),
	webConfig: z.string().optional().nullable().default(null).describe("web config is information stored in the layout table - the content is only releavant for the web app")
});

/** Responsible: JMQ, Updated: 20190123 */
export class WebTypeViewField {
	constructor(
		public fieldName: string,
		public label: string,
		public shortLabel: string,
		public webSimpleType: WebSimpleTypeEnum,
		public webMetaType: WebMetaTypeEnum,
		/** some metatypes has a name objectlist, enum,.... for minutoffset and dataoffset the name are either start or end, for datetime it's empty */
		public typeName: string | null = null,
		/** some metatypes has a parameter length/precision. text : length, real : precision, dateoffset/minutoffset/datetime : 8/12/17 number of used digits in YYYYMMDDHHMISSQQQ */
		public length: number | null = null,
		/** types: field order equals representation order */
		public recordType: WebRecordType | null = null,
		/** web config is information stored in the layout table - the content is only releavant for the web app */
		public webConfig: string | null = null,
	) {}
}

export const webFieldSchema = z.object({
	name: z.string(),
	data: z.array(z.any()).optional().nullable().default(null),
	value: z.string().optional().nullable().default(null)
});

export const webFieldJsonSchema = z.object({
	name: z.string().describe("field name - same as in webTypeViewField"),
	data: z.array(z.any()).optional().nullable().default(null).describe("field is an object list. Undefined means []"),
	value: z.string().optional().nullable().default(null).describe("field value as text")
});

/** Responsible: JMQ, Updated: 20190123 */
export class WebField {
	constructor(
		/** field name - same as in webTypeViewField */
		public name: string,
		/** field is an object list. Undefined means [] */
		public data: WebRecord[] | null = null,
		/** field value as text */
		public value: string | null = null,
	) {}
}

export const webRecordSchema = z.object({
	primaryKey: z.string(),
	record: z.array(z.any())
});

export const webRecordJsonSchema = z.object({
	primaryKey: z.string().describe("primary key for record"),
	record: z.array(z.any())
});

/** Responsible: JMQ, Updated: 20190123 */
export class WebRecord {
	constructor(
		/** primary key for record */
		public primaryKey: string,
		public record: WebField[],
	) {}
}

export const webListSchema = z.object({
	listName: z.string(),
	objectName: z.string(),
	recordType: z.any(),
	data: z.array(z.any())
});

export const webListJsonSchema = z.object({
	listName: z.string().describe("uiLayout.name - uiLayout.internal is given from scope"),
	objectName: z.string(),
	recordType: z.any().describe("types: field order equals representation order"),
	data: z.array(z.any()).describe("order equals sorting order")
});

/** Responsible: JMQ, Updated: 20190123 */
export class WebList {
	constructor(
		/** uiLayout.name - uiLayout.internal is given from scope */
		public listName: string,
		public objectName: string,
		/** types: field order equals representation order */
		public recordType: WebRecordType,
		/** order equals sorting order */
		public data: WebRecord[],
	) {}
}

export const webElementSchema = z.object({
	listName: z.string(),
	objectName: z.string(),
	recordType: z.any(),
	record: z.any()
});

export const webElementJsonSchema = z.object({
	listName: z.string().describe("uiLayout.name - uiLayout.internal is given from scope"),
	objectName: z.string(),
	recordType: z.any().describe("types: field order equals representation order"),
	record: z.any()
});

/** Responsible: JMQ, Updated: 20190123 */
export class WebElement {
	constructor(
		/** uiLayout.name - uiLayout.internal is given from scope */
		public listName: string,
		public objectName: string,
		/** types: field order equals representation order */
		public recordType: WebRecordType,
		public record: WebRecord,
	) {}
}

export const globalSettingsSchema = z.object({
	enableBiometricAuthentication: z.boolean(),
	idleLogoutSeconds: z.int(),
	logonMethod: LogonTypeSchema,
	supporterLogonMethod: LogonTypeSchema,
	supporterLogonIdFields: z.array(SupporterLogonIdFieldSchema),
	useDateTime: z.coerce.date(),
	useDateTimeType: UseDateTimeTypeSchema,
	openIdAcrValuesEmployee: z.string().optional().nullable().default(null),
	openIdAcrValuesPlanner: z.string().optional().nullable().default(null),
	openIdAcrValuesSupporter: z.string().optional().nullable().default(null),
	openIdAuthorizationEndpoint: z.string().optional().nullable().default(null),
	openIdClientId: z.string().optional().nullable().default(null),
	openIdClientIdSupporter: z.string().optional().nullable().default(null),
	openIdLogoutEndpoint: z.string().optional().nullable().default(null),
	openIdRedirectUriEmployee: z.string().optional().nullable().default(null),
	openIdRedirectUriPlanner: z.string().optional().nullable().default(null),
	openIdRedirectUriSupporter: z.string().optional().nullable().default(null),
	openIdResource: z.string().optional().nullable().default(null),
	openIdResponseType: z.string().optional().nullable().default(null),
	openIdScopeEmployee: z.string().optional().nullable().default(null),
	openIdScopePlanner: z.string().optional().nullable().default(null),
	openIdScopeSupporter: z.string().optional().nullable().default(null)
});

export const globalSettingsJsonSchema = z.object({
	enableBiometricAuthentication: z.boolean().describe("Whether biometric authentication is possible"),
	idleLogoutSeconds: z.int().describe("Number of seconds of inactivity before the user is logged out automatically"),
	logonMethod: LogonTypeJsonSchema.describe("Which method is used to logon, e.g. openId, windows or staffWebUser"),
	supporterLogonMethod: LogonTypeJsonSchema.describe("Which method is used by supporters to logon"),
	supporterLogonIdFields: z.array(SupporterLogonIdFieldJsonSchema).describe("Which fields uniquely identify an employee for supporter logon"),
	useDateTime: z.iso.datetime({ local: true }),
	useDateTimeType: UseDateTimeTypeJsonSchema,
	openIdAcrValuesEmployee: z.string().optional().nullable().default(null),
	openIdAcrValuesPlanner: z.string().optional().nullable().default(null),
	openIdAcrValuesSupporter: z.string().optional().nullable().default(null),
	openIdAuthorizationEndpoint: z.string().optional().nullable().default(null),
	openIdClientId: z.string().optional().nullable().default(null),
	openIdClientIdSupporter: z.string().optional().nullable().default(null),
	openIdLogoutEndpoint: z.string().optional().nullable().default(null),
	openIdRedirectUriEmployee: z.string().optional().nullable().default(null),
	openIdRedirectUriPlanner: z.string().optional().nullable().default(null),
	openIdRedirectUriSupporter: z.string().optional().nullable().default(null),
	openIdResource: z.string().optional().nullable().default(null),
	openIdResponseType: z.string().optional().nullable().default(null),
	openIdScopeEmployee: z.string().optional().nullable().default(null),
	openIdScopePlanner: z.string().optional().nullable().default(null),
	openIdScopeSupporter: z.string().optional().nullable().default(null)
}).describe("Settings defined which can be read before logon (see getGlobalSettings). The OpenID settings are only returned if logonMethod is set to \"OpenId\". The *Supporter settings are used for supporter logon in MyPlan, which has its own OpenID client (wi172762).");

/**
	Settings defined which can be read before logon (see getGlobalSettings). The OpenID settings are only returned if logonMethod is set to "OpenId". The *Supporter settings are used for supporter logon in MyPlan, which has its own OpenID client (wi172762).
	Responsible: AGRU, Updated: 20261005
*/
export class GlobalSettings {
	constructor(
		/** Whether biometric authentication is possible */
		public enableBiometricAuthentication: boolean,
		/** Number of seconds of inactivity before the user is logged out automatically */
		public idleLogoutSeconds: number,
		/** Which method is used to logon, e.g. openId, windows or staffWebUser */
		public logonMethod: LogonTypeEnum,
		/** Which method is used by supporters to logon */
		public supporterLogonMethod: LogonTypeEnum,
		/** Which fields uniquely identify an employee for supporter logon */
		public supporterLogonIdFields: SupporterLogonIdFieldEnum[],
		public useDateTime: Date,
		public useDateTimeType: UseDateTimeTypeEnum,
		public openIdAcrValuesEmployee: string | null = null,
		public openIdAcrValuesPlanner: string | null = null,
		public openIdAcrValuesSupporter: string | null = null,
		public openIdAuthorizationEndpoint: string | null = null,
		public openIdClientId: string | null = null,
		public openIdClientIdSupporter: string | null = null,
		public openIdLogoutEndpoint: string | null = null,
		public openIdRedirectUriEmployee: string | null = null,
		public openIdRedirectUriPlanner: string | null = null,
		public openIdRedirectUriSupporter: string | null = null,
		public openIdResource: string | null = null,
		public openIdResponseType: string | null = null,
		public openIdScopeEmployee: string | null = null,
		public openIdScopePlanner: string | null = null,
		public openIdScopeSupporter: string | null = null,
	) {}
}

export const logonSettingsSchema = z.object({
	pwdMinLength: z.int(),
	pwdMinUniq: z.int(),
	pwdMinDiff: z.int(),
	pwdDigits: z.int(),
	pwdUpperLetters: z.int(),
	pwdLowerLetters: z.int(),
	pwdSpecialLetters: z.int(),
	noPassword: z.boolean(),
	adPassword: z.boolean(),
	reuseCheck: z.int(),
	lockoutDuration: z.array(z.int()),
	minPwdAge: z.int(),
	maxPwdAge: z.int()
});

export const logonSettingsJsonSchema = z.object({
	pwdMinLength: z.int().describe("minimum password length"),
	pwdMinUniq: z.int().describe("minimum uniq characters"),
	pwdMinDiff: z.int().describe("minimum number different characters"),
	pwdDigits: z.int().describe("minimum number of digits in a password"),
	pwdUpperLetters: z.int().describe("minimum number of uppercase letters in a password"),
	pwdLowerLetters: z.int().describe("minimum number of lowercase letters in a password"),
	pwdSpecialLetters: z.int().describe("minimum number of special letters in a password"),
	noPassword: z.boolean().describe("don't use password - something else"),
	adPassword: z.boolean().describe("don't use password - use Active Directory"),
	reuseCheck: z.int().describe("how many earlier passwords are checked"),
	lockoutDuration: z.array(z.int()).describe("duration between failed logons - after last number is used the account is locked"),
	minPwdAge: z.int().describe("days between password change"),
	maxPwdAge: z.int().describe("maximum number of days between password change")
});

/** Responsible: JMQ, Updated: 20180410 */
export class LogonSettings {
	constructor(
		/** minimum password length */
		public pwdMinLength: number,
		/** minimum uniq characters */
		public pwdMinUniq: number,
		/** minimum number different characters */
		public pwdMinDiff: number,
		/** minimum number of digits in a password */
		public pwdDigits: number,
		/** minimum number of uppercase letters in a password */
		public pwdUpperLetters: number,
		/** minimum number of lowercase letters in a password */
		public pwdLowerLetters: number,
		/** minimum number of special letters in a password */
		public pwdSpecialLetters: number,
		/** don't use password - something else */
		public noPassword: boolean,
		/** don't use password - use Active Directory */
		public adPassword: boolean,
		/** how many earlier passwords are checked */
		public reuseCheck: number,
		/** duration between failed logons - after last number is used the account is locked */
		public lockoutDuration: number[],
		/** days between password change */
		public minPwdAge: number,
		/** maximum number of days between password change */
		public maxPwdAge: number,
	) {}
}

export const webSortConfigSchema = z.object({
	fieldName: z.string(),
	ascending: z.boolean()
});

export const webSortConfigJsonSchema = z.object({
	fieldName: z.string().describe("Name in the datamodel, name can be an expression"),
	ascending: z.boolean().describe("sort order")
});

/** Responsible: JMQ, Updated: 20190205 */
export class WebSortConfig {
	constructor(
		/** Name in the datamodel, name can be an expression */
		public fieldName: string,
		/** sort order */
		public ascending: boolean,
	) {}
}

export const webFieldConfigSchema = z.object({
	fieldName: z.string(),
	listConfig: z.lazy(() => webListConfigSchema).optional().nullable().default(null)
});

export const webFieldConfigJsonSchema = z.object({
	fieldName: z.string().describe("Name in the datamodel, name can be an expression"),
	listConfig: z.lazy(() => webListConfigJsonSchema).optional().nullable().default(null).describe("config needed if the field is an objectlist")
});

/** Responsible: JMQ, Updated: 20190205 */
export class WebFieldConfig {
	constructor(
		/** Name in the datamodel, name can be an expression */
		public fieldName: string,
		/** config needed if the field is an objectlist */
		public listConfig: WebListConfig | null = null,
	) {}
}

export const webListConfigSchema = z.object({
	fieldList: z.array(z.any()),
	sortList: z.array(z.lazy(() => webSortConfigSchema)).optional().nullable().default(null),
	filter: z.string().optional().nullable().default(null),
	webConfig: z.string().optional().nullable().default(null)
});

export const webListConfigJsonSchema = z.object({
	fieldList: z.array(z.any()).describe("Field Elements"),
	sortList: z.array(z.lazy(() => webSortConfigJsonSchema)).optional().nullable().default(null).describe("sorted by. undefined means []"),
	filter: z.string().optional().nullable().default(null).describe("objRecord filter expression"),
	webConfig: z.string().optional().nullable().default(null).describe("Info about rendering")
});

/** Responsible: JMQ, Updated: 20190205 */
export class WebListConfig {
	constructor(
		/** Field Elements */
		public fieldList: WebFieldConfig[],
		/** sorted by. undefined means [] */
		public sortList: WebSortConfig[] | null = null,
		/** objRecord filter expression */
		public filter: string | null = null,
		/** Info about rendering */
		public webConfig: string | null = null,
	) {}
}

export const webRecordTypeSchema = z.object({
	fieldList: z.array(z.any()),
	sortList: z.array(z.lazy(() => webSortConfigSchema)).optional().nullable().default(null),
	filter: z.string().optional().nullable().default(null),
	webConfig: z.string().optional().nullable().default(null)
});

export const webRecordTypeJsonSchema = z.object({
	fieldList: z.array(z.any()).describe("name and type . Field order equals representation order"),
	sortList: z.array(z.lazy(() => webSortConfigJsonSchema)).optional().nullable().default(null).describe("sorted by. Undefined means []"),
	filter: z.string().optional().nullable().default(null).describe("objRecord filter expression"),
	webConfig: z.string().optional().nullable().default(null).describe("Info about rendering")
});

/** Responsible: JMQ, Updated: 20190205 */
export class WebRecordType {
	constructor(
		/** name and type . Field order equals representation order */
		public fieldList: WebTypeViewField[],
		/** sorted by. Undefined means [] */
		public sortList: WebSortConfig[] | null = null,
		/** objRecord filter expression */
		public filter: string | null = null,
		/** Info about rendering */
		public webConfig: string | null = null,
	) {}
}

export const wsRefOrgunitByInfoSchema = z.object({
	info1: z.string().optional().nullable().default(null),
	info2: z.string().optional().nullable().default(null),
	info3: z.string().optional().nullable().default(null)
});

export const wsRefOrgunitByInfoJsonSchema = z.object({
	info1: z.string().optional().nullable().default(null),
	info2: z.string().optional().nullable().default(null),
	info3: z.string().optional().nullable().default(null)
}).describe("Orgunit identified by Info1, Info2 or Info3.");

/**
	Orgunit identified by Info1, Info2 or Info3.
	Responsible: MB, Updated: 2022
*/
export class WsRefOrgunitByInfo {
	constructor(
		public info1: string | null = null,
		public info2: string | null = null,
		public info3: string | null = null,
	) {}
}

export const wsRefOrgunitSchema = z.object({
	unitid: z.string().optional().nullable().default(null),
	path: z.string().optional().nullable().default(null),
	institutionLabel: z.string().optional().nullable().default(null),
	externalkey: z.string().optional().nullable().default(null),
	info: z.lazy(() => wsRefOrgunitByInfoSchema).optional().nullable().default(null)
});

export const wsRefOrgunitJsonSchema = z.object({
	unitid: z.string().optional().nullable().default(null),
	path: z.string().optional().nullable().default(null),
	institutionLabel: z.string().optional().nullable().default(null).describe("Orgunit with institution property and this label"),
	externalkey: z.string().optional().nullable().default(null),
	info: z.lazy(() => wsRefOrgunitByInfoJsonSchema).optional().nullable().default(null)
}).describe("Reference to Orgunit with different options. First defined option is used. All are optional, but one must be specified");

/**
	Reference to Orgunit with different options. First defined option is used. All are optional, but one must be specified
	Responsible: MB, Updated: 2022
*/
export class WsRefOrgunit {
	constructor(
		public unitid: string | null = null,
		public path: string | null = null,
		/** Orgunit with institution property and this label */
		public institutionLabel: string | null = null,
		public externalkey: string | null = null,
		public info: WsRefOrgunitByInfo | null = null,
	) {}
}

export const wsRefPersonBySalaryIdSchema = z.object({
	salaryid: z.string(),
	validAt: z.coerce.date().optional().nullable().default(null),
	institution: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null),
	department: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null)
});

export const wsRefPersonBySalaryIdJsonSchema = z.object({
	salaryid: z.string(),
	validAt: z.iso.datetime({ local: true }).optional().nullable().default(null).describe("Validate by person1 validity"),
	institution: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null).describe("Validate by person2 unit. Unit should be under the institution"),
	department: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null).describe("Validate by person2 unit")
}).describe("Person identified by SalaryId, optionally qualified by Institution Orgunit or Planning Department Orgunit When salaryIds are reused validAt parameter may be specified to distinguish different persons");

/**
	Person identified by SalaryId, optionally qualified by Institution Orgunit or Planning Department Orgunit When salaryIds are reused validAt parameter may be specified to distinguish different persons
	Responsible: MB, Updated: 2022
*/
export class WsRefPersonBySalaryId {
	constructor(
		public salaryid: string,
		/** Validate by person1 validity */
		public validAt: Date | null = null,
		/** Validate by person2 unit. Unit should be under the institution */
		public institution: WsRefOrgunit | null = null,
		/** Validate by person2 unit */
		public department: WsRefOrgunit | null = null,
	) {}
}

export const wsRefPersonByAuxSchema = z.object({
	aux1: z.string().optional().nullable().default(null),
	aux2: z.string().optional().nullable().default(null),
	aux3: z.string().optional().nullable().default(null),
	validAt: z.coerce.date().optional().nullable().default(null),
	institution: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null),
	department: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null)
});

export const wsRefPersonByAuxJsonSchema = z.object({
	aux1: z.string().optional().nullable().default(null),
	aux2: z.string().optional().nullable().default(null),
	aux3: z.string().optional().nullable().default(null),
	validAt: z.iso.datetime({ local: true }).optional().nullable().default(null).describe("Validate by person1 validity"),
	institution: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null).describe("Validate by person2 unit. Unit should be under the institution"),
	department: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null).describe("Validate by person2 unit")
}).describe("Person identified by Aux1, Aux2 or Aux3 If Aux information isn't globally unique then ValidAt, Institution and Department may be specified to distinguish different persons");

/**
	Person identified by Aux1, Aux2 or Aux3 If Aux information isn't globally unique then ValidAt, Institution and Department may be specified to distinguish different persons
	Responsible: MB, Updated: 2022
*/
export class WsRefPersonByAux {
	constructor(
		public aux1: string | null = null,
		public aux2: string | null = null,
		public aux3: string | null = null,
		/** Validate by person1 validity */
		public validAt: Date | null = null,
		/** Validate by person2 unit. Unit should be under the institution */
		public institution: WsRefOrgunit | null = null,
		/** Validate by person2 unit */
		public department: WsRefOrgunit | null = null,
	) {}
}

export const wsRefPersonByNameSchema = z.object({
	name: z.string(),
	validAt: z.coerce.date().optional().nullable().default(null),
	institution: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null),
	department: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null)
});

export const wsRefPersonByNameJsonSchema = z.object({
	name: z.string(),
	validAt: z.iso.datetime({ local: true }).optional().nullable().default(null).describe("Validate by person1 validity"),
	institution: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null).describe("Validate by person2 unit. Unit should be under the institution"),
	department: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null).describe("Validate by person2 unit")
}).describe("Person identified by Name We require at least one of the qualifiers ValidAt, Institution and Department to distinguish different persons with same name");

/**
	Person identified by Name We require at least one of the qualifiers ValidAt, Institution and Department to distinguish different persons with same name
	Responsible: MB, Updated: 2022
*/
export class WsRefPersonByName {
	constructor(
		public name: string,
		/** Validate by person1 validity */
		public validAt: Date | null = null,
		/** Validate by person2 unit. Unit should be under the institution */
		public institution: WsRefOrgunit | null = null,
		/** Validate by person2 unit */
		public department: WsRefOrgunit | null = null,
	) {}
}

export const wsRefPersonSchema = z.object({
	personid: z.int().optional().nullable().default(null),
	salaryid: z.lazy(() => wsRefPersonBySalaryIdSchema).optional().nullable().default(null),
	auxid: z.lazy(() => wsRefPersonByAuxSchema).optional().nullable().default(null),
	name: z.lazy(() => wsRefPersonByNameSchema).optional().nullable().default(null),
	externalkey: z.string().optional().nullable().default(null)
});

export const wsRefPersonJsonSchema = z.object({
	personid: z.int().optional().nullable().default(null),
	salaryid: z.lazy(() => wsRefPersonBySalaryIdJsonSchema).optional().nullable().default(null),
	auxid: z.lazy(() => wsRefPersonByAuxJsonSchema).optional().nullable().default(null),
	name: z.lazy(() => wsRefPersonByNameJsonSchema).optional().nullable().default(null),
	externalkey: z.string().optional().nullable().default(null)
}).describe("Reference to person with different options. First defined option is used. All are optional, but one must be specified");

/**
	Reference to person with different options. First defined option is used. All are optional, but one must be specified
	Responsible: MB, Updated: 2022
*/
export class WsRefPerson {
	constructor(
		public personid: number | null = null,
		public salaryid: WsRefPersonBySalaryId | null = null,
		public auxid: WsRefPersonByAux | null = null,
		public name: WsRefPersonByName | null = null,
		public externalkey: string | null = null,
	) {}
}

export const wsRefShiftTypeByExternalIdSchema = z.object({
	externalid: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null)
});

export const wsRefShiftTypeByExternalIdJsonSchema = z.object({
	externalid: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null)
}).describe("ShiftType identified by ExternalKey Qualifiers Orgunit may be used to distinguish different shiftTypes if ExternalKeys aren't globally unique");

/**
	ShiftType identified by ExternalKey Qualifiers Orgunit may be used to distinguish different shiftTypes if ExternalKeys aren't globally unique
	Responsible: MB, Updated: 2022
*/
export class WsRefShiftTypeByExternalId {
	constructor(
		public externalid: string,
		public orgunit: WsRefOrgunit | null = null,
	) {}
}

export const wsRefShiftTypeByNameSchema = z.object({
	name: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null)
});

export const wsRefShiftTypeByNameJsonSchema = z.object({
	name: z.string().describe("shiftTypeLabel"),
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null)
}).describe("ShiftType identified by Name Qualifiers Orgunit are typically required to distinguish different shiftTypes with same name");

/**
	ShiftType identified by Name Qualifiers Orgunit are typically required to distinguish different shiftTypes with same name
	Responsible: MB, Updated: 2022
*/
export class WsRefShiftTypeByName {
	constructor(
		/** shiftTypeLabel */
		public name: string,
		public orgunit: WsRefOrgunit | null = null,
	) {}
}

export const wsRefShifttypeSchema = z.object({
	shiftTypeId: z.string().optional().nullable().default(null),
	externalId: z.lazy(() => wsRefShiftTypeByExternalIdSchema).optional().nullable().default(null),
	name: z.lazy(() => wsRefShiftTypeByNameSchema).optional().nullable().default(null),
	salarySort: z.string().optional().nullable().default(null)
});

export const wsRefShifttypeJsonSchema = z.object({
	shiftTypeId: z.string().optional().nullable().default(null),
	externalId: z.lazy(() => wsRefShiftTypeByExternalIdJsonSchema).optional().nullable().default(null),
	name: z.lazy(() => wsRefShiftTypeByNameJsonSchema).optional().nullable().default(null),
	salarySort: z.string().optional().nullable().default(null).describe("salarySort of the shiftType if the salarySort is not none")
}).describe("Reference to ShiftType with different options and salarySort. First defined option is used. All are optional, but one must be specified");

/**
	Reference to ShiftType with different options and salarySort. First defined option is used. All are optional, but one must be specified
	Responsible: MB, Updated: 20260702
*/
export class WsRefShifttype {
	constructor(
		public shiftTypeId: string | null = null,
		public externalId: WsRefShiftTypeByExternalId | null = null,
		public name: WsRefShiftTypeByName | null = null,
		/** salarySort of the shiftType if the salarySort is not none */
		public salarySort: string | null = null,
	) {}
}

export const wsRefShiftCounterSchema = z.object({
	counterid: z.int().optional().nullable().default(null),
	counterName: z.string().optional().nullable().default(null)
});

export const wsRefShiftCounterJsonSchema = z.object({
	counterid: z.int().optional().nullable().default(null),
	counterName: z.string().optional().nullable().default(null)
}).describe("Reference to ShiftCount with different options. All are optional, but one must at least be specified");

/**
	Reference to ShiftCount with different options. All are optional, but one must at least be specified
	Responsible: MB, Updated: 2022
*/
export class WsRefShiftCounter {
	constructor(
		public counterid: number | null = null,
		public counterName: string | null = null,
	) {}
}

export const wsRefShiftDefByIdSchema = z.object({
	shiftid: z.string(),
	validAt: z.coerce.date()
});

export const wsRefShiftDefByIdJsonSchema = z.object({
	shiftid: z.string(),
	validAt: z.iso.datetime({ local: true })
}).describe("Reference to Shift definition by internal Id combined with validity.");

/**
	Reference to Shift definition by internal Id combined with validity.
	Responsible: MB, Updated: 2022
*/
export class WsRefShiftDefById {
	constructor(
		public shiftid: string,
		public validAt: Date,
	) {}
}

export const wsRefShiftDefByNameSchema = z.object({
	name: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitSchema),
	validAt: z.coerce.date()
});

export const wsRefShiftDefByNameJsonSchema = z.object({
	name: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema),
	validAt: z.iso.datetime({ local: true })
}).describe("Reference to a Shift definition by name.");

/**
	Reference to a Shift definition by name.
	Responsible: MB, Updated: 2022
*/
export class WsRefShiftDefByName {
	constructor(
		public name: string,
		public orgunit: WsRefOrgunit,
		public validAt: Date,
	) {}
}

export const wsRefShiftDefByExternalIdSchema = z.object({
	externalId: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null)
});

export const wsRefShiftDefByExternalIdJsonSchema = z.object({
	externalId: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null)
}).describe("Reference to a Shift definition by externalid. If external id is globally unique then orgunit may be undefined. Otherwise externalid must be qualified by orgunit");

/**
	Reference to a Shift definition by externalid. If external id is globally unique then orgunit may be undefined. Otherwise externalid must be qualified by orgunit
	Responsible: MB, Updated: 2022
*/
export class WsRefShiftDefByExternalId {
	constructor(
		public externalId: string,
		public orgunit: WsRefOrgunit | null = null,
	) {}
}

export const wsRefShiftDefSchema = z.object({
	id: z.lazy(() => wsRefShiftDefByIdSchema).optional().nullable().default(null),
	name: z.lazy(() => wsRefShiftDefByNameSchema).optional().nullable().default(null),
	externalId: z.lazy(() => wsRefShiftDefByExternalIdSchema).optional().nullable().default(null)
});

export const wsRefShiftDefJsonSchema = z.object({
	id: z.lazy(() => wsRefShiftDefByIdJsonSchema).optional().nullable().default(null),
	name: z.lazy(() => wsRefShiftDefByNameJsonSchema).optional().nullable().default(null),
	externalId: z.lazy(() => wsRefShiftDefByExternalIdJsonSchema).optional().nullable().default(null)
}).describe("Reference to a Shift definition with different options. First defined option is used. All are optional, but one must be specified");

/**
	Reference to a Shift definition with different options. First defined option is used. All are optional, but one must be specified
	Responsible: MB, Updated: 2022
*/
export class WsRefShiftDef {
	constructor(
		public id: WsRefShiftDefById | null = null,
		public name: WsRefShiftDefByName | null = null,
		public externalId: WsRefShiftDefByExternalId | null = null,
	) {}
}

export const wsRefTaskDefByNameSchema = z.object({
	name: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitSchema),
	validAt: z.coerce.date()
});

export const wsRefTaskDefByNameJsonSchema = z.object({
	name: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema),
	validAt: z.iso.datetime({ local: true })
}).describe("Reference to Task definition by name.");

/**
	Reference to Task definition by name.
	Responsible: MB, Updated: 2022
*/
export class WsRefTaskDefByName {
	constructor(
		public name: string,
		public orgunit: WsRefOrgunit,
		public validAt: Date,
	) {}
}

export const wsRefTaskDefByExternalIdSchema = z.object({
	externalId: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null)
});

export const wsRefTaskDefByExternalIdJsonSchema = z.object({
	externalId: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null)
}).describe("Reference to Task definition by externalid. If external id is globally unique then orgunit may be undefined. Otherwise externalid must be qualified by orgunit");

/**
	Reference to Task definition by externalid. If external id is globally unique then orgunit may be undefined. Otherwise externalid must be qualified by orgunit
	Responsible: MB, Updated: 2022
*/
export class WsRefTaskDefByExternalId {
	constructor(
		public externalId: string,
		public orgunit: WsRefOrgunit | null = null,
	) {}
}

export const wsRefTaskDefSchema = z.object({
	id: z.int().optional().nullable().default(null),
	name: z.lazy(() => wsRefTaskDefByNameSchema).optional().nullable().default(null),
	externalId: z.lazy(() => wsRefTaskDefByExternalIdSchema).optional().nullable().default(null)
});

export const wsRefTaskDefJsonSchema = z.object({
	id: z.int().optional().nullable().default(null),
	name: z.lazy(() => wsRefTaskDefByNameJsonSchema).optional().nullable().default(null),
	externalId: z.lazy(() => wsRefTaskDefByExternalIdJsonSchema).optional().nullable().default(null)
}).describe("Reference to Task definition with different options. First defined option is used. All are optional, but one must be specified");

/**
	Reference to Task definition with different options. First defined option is used. All are optional, but one must be specified
	Responsible: MB, Updated: 2022
*/
export class WsRefTaskDef {
	constructor(
		public id: number | null = null,
		public name: WsRefTaskDefByName | null = null,
		public externalId: WsRefTaskDefByExternalId | null = null,
	) {}
}

export const wsRefTaskByNameSchema = z.object({
	name: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitSchema),
	validAt: z.coerce.date()
});

export const wsRefTaskByNameJsonSchema = z.object({
	name: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema),
	validAt: z.iso.datetime({ local: true })
}).describe("Reference to Task by name.");

/**
	Reference to Task by name.
	Responsible: MB, Updated: 2022
*/
export class WsRefTaskByName {
	constructor(
		public name: string,
		public orgunit: WsRefOrgunit,
		public validAt: Date,
	) {}
}

export const wsRefTaskByExternalIdSchema = z.object({
	externalId: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitSchema).optional().nullable().default(null)
});

export const wsRefTaskByExternalIdJsonSchema = z.object({
	externalId: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema).optional().nullable().default(null)
}).describe("Reference to Task definition by externalid. If external id is globally unique then orgunit may be undefined. Otherwise externalid must be qualified by orgunit");

/**
	Reference to Task definition by externalid. If external id is globally unique then orgunit may be undefined. Otherwise externalid must be qualified by orgunit
	Responsible: MB, Updated: 2022
*/
export class WsRefTaskByExternalId {
	constructor(
		public externalId: string,
		public orgunit: WsRefOrgunit | null = null,
	) {}
}

export const wsRefTaskSchema = z.object({
	id: z.int().optional().nullable().default(null),
	name: z.lazy(() => wsRefTaskByNameSchema).optional().nullable().default(null),
	externalId: z.lazy(() => wsRefTaskByExternalIdSchema).optional().nullable().default(null)
});

export const wsRefTaskJsonSchema = z.object({
	id: z.int().optional().nullable().default(null),
	name: z.lazy(() => wsRefTaskByNameJsonSchema).optional().nullable().default(null),
	externalId: z.lazy(() => wsRefTaskByExternalIdJsonSchema).optional().nullable().default(null)
}).describe("Reference to Task with different options. First defined option is used. All are optional, but one must be specified");

/**
	Reference to Task with different options. First defined option is used. All are optional, but one must be specified
	Responsible: MB, Updated: 2022
*/
export class WsRefTask {
	constructor(
		public id: number | null = null,
		public name: WsRefTaskByName | null = null,
		public externalId: WsRefTaskByExternalId | null = null,
	) {}
}

export const wsRefAccountByNameSchema = z.object({
	name: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitSchema)
});

export const wsRefAccountByNameJsonSchema = z.object({
	name: z.string().describe("Account label"),
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema)
}).describe("Account identified by Name Qualifiers Orgunit are typically required to distinguish different Account with same name");

/**
	Account identified by Name Qualifiers Orgunit are typically required to distinguish different Account with same name
	Responsible: AW, Updated: 2023
*/
export class WsRefAccountByName {
	constructor(
		/** Account label */
		public name: string,
		public orgunit: WsRefOrgunit,
	) {}
}

export const wsRefAccountSchema = z.object({
	accountId: z.int().optional().nullable().default(null),
	externalId: z.string().optional().nullable().default(null),
	name: z.lazy(() => wsRefAccountByNameSchema).optional().nullable().default(null)
});

export const wsRefAccountJsonSchema = z.object({
	accountId: z.int().optional().nullable().default(null),
	externalId: z.string().optional().nullable().default(null),
	name: z.lazy(() => wsRefAccountByNameJsonSchema).optional().nullable().default(null)
}).describe("Reference to Account with different options. First defined option is used. All are optional, but one must be specified");

/**
	Reference to Account with different options. First defined option is used. All are optional, but one must be specified
	Responsible: AW, Updated: 2023
*/
export class WsRefAccount {
	constructor(
		public accountId: number | null = null,
		public externalId: string | null = null,
		public name: WsRefAccountByName | null = null,
	) {}
}

export const wsRefProjectByNameSchema = z.object({
	name: z.string(),
	orgunit: z.lazy(() => wsRefOrgunitSchema)
});

export const wsRefProjectByNameJsonSchema = z.object({
	name: z.string().describe("project label"),
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema)
}).describe("Project identified by Name Qualifiers Orgunit are typically required to distinguish different Project with same name");

/**
	Project identified by Name Qualifiers Orgunit are typically required to distinguish different Project with same name
	Responsible: AW, Updated: 2023
*/
export class WsRefProjectByName {
	constructor(
		/** project label */
		public name: string,
		public orgunit: WsRefOrgunit,
	) {}
}

export const wsRefProjectSchema = z.object({
	projectId: z.int().optional().nullable().default(null),
	externalId: z.string().optional().nullable().default(null),
	name: z.lazy(() => wsRefProjectByNameSchema).optional().nullable().default(null)
});

export const wsRefProjectJsonSchema = z.object({
	projectId: z.int().optional().nullable().default(null),
	externalId: z.string().optional().nullable().default(null),
	name: z.lazy(() => wsRefProjectByNameJsonSchema).optional().nullable().default(null)
}).describe("Reference to project with different options. First defined option is used. All are optional, but one must be specified");

/**
	Reference to project with different options. First defined option is used. All are optional, but one must be specified
	Responsible: AW, Updated: 2023
*/
export class WsRefProject {
	constructor(
		public projectId: number | null = null,
		public externalId: string | null = null,
		public name: WsRefProjectByName | null = null,
	) {}
}

export const wsRefDimensionItemByNameSchema = z.object({
	name: z.string(),
	dimension: DimensionEnumSchema,
	orgunit: z.lazy(() => wsRefOrgunitSchema)
});

export const wsRefDimensionItemByNameJsonSchema = z.object({
	name: z.string(),
	dimension: DimensionEnumJsonSchema,
	orgunit: z.lazy(() => wsRefOrgunitJsonSchema)
}).describe("Dimension item identified by Name");

/**
	Dimension item identified by Name
	Responsible: AW, Updated: 2023
*/
export class WsRefDimensionItemByName {
	constructor(
		public name: string,
		public dimension: DimensionEnumEnum,
		public orgunit: WsRefOrgunit,
	) {}
}

export const wsRefDimensionItemSchema = z.object({
	dimensionItemId: z.int().optional().nullable().default(null),
	name: z.lazy(() => wsRefDimensionItemByNameSchema).optional().nullable().default(null)
});

export const wsRefDimensionItemJsonSchema = z.object({
	dimensionItemId: z.int().optional().nullable().default(null),
	name: z.lazy(() => wsRefDimensionItemByNameJsonSchema).optional().nullable().default(null)
}).describe("Reference to Dimension item with different options. First defined option is used. All are optional, but one must be specified");

/**
	Reference to Dimension item with different options. First defined option is used. All are optional, but one must be specified
	Responsible: AW, Updated: 2023
*/
export class WsRefDimensionItem {
	constructor(
		public dimensionItemId: number | null = null,
		public name: WsRefDimensionItemByName | null = null,
	) {}
}

export const personInfoSchema = z.object({
	personId: z.int(),
	name: z.string(),
	initials: z.string(),
	phone: z.string(),
	phone2: z.string(),
	phone3: z.string(),
	email: z.string(),
	title: z.string(),
	fictive: z.boolean(),
	realizedPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }),
	approvedPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }),
	planPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }),
	requestPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }),
	validity: z.object({ from: z.coerce.date(), to: z.coerce.date() })
});

export const personInfoJsonSchema = z.object({
	personId: z.int(),
	name: z.string(),
	initials: z.string(),
	phone: z.string(),
	phone2: z.string(),
	phone3: z.string(),
	email: z.string(),
	title: z.string(),
	fictive: z.boolean(),
	realizedPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }),
	approvedPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }),
	planPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }),
	requestPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }),
	validity: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })
});

/** Responsible: ABJ, Updated: 20170710 */
export class PersonInfo {
	constructor(
		public personId: number,
		public name: string,
		public initials: string,
		public phone: string,
		public phone2: string,
		public phone3: string,
		public email: string,
		public title: string,
		public fictive: boolean,
		public realizedPeriod: DomainWsIntervalType,
		public approvedPeriod: DomainWsIntervalType,
		public planPeriod: DomainWsIntervalType,
		public requestPeriod: DomainWsIntervalType,
		public validity: DomainWsIntervalType,
	) {}
}

export const personGroupMemberSchema = z.object({
	personGroupId: z.string(),
	personId: z.int(),
	validity: z.object({ from: z.coerce.date(), to: z.coerce.date() })
});

export const personGroupMemberJsonSchema = z.object({
	personGroupId: z.string(),
	personId: z.int(),
	validity: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })
});

/** Responsible: ABJ, Updated: 20170708 */
export class PersonGroupMember {
	constructor(
		public personGroupId: string,
		public personId: number,
		public validity: DomainWsIntervalType,
	) {}
}

export const personGroupMembershipChangeInfoSchema = z.object({
	personId: z.int(),
	onlyMembership: z.boolean(),
	functionPlanned: z.boolean(),
	payrollTransferred: z.boolean(),
	operationPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() })
});

export const personGroupMembershipChangeInfoJsonSchema = z.object({
	personId: z.int().describe("The person this info concerns"),
	onlyMembership: z.boolean().describe("True if removing/shortening over the period leaves the person without any person-group membership under the unit (would trigger the invariant)"),
	functionPlanned: z.boolean().describe("True if removing this membership over the period orphans function assignments (not covered by another membership)"),
	payrollTransferred: z.boolean().describe("True if any orphaned function falls in a salary-transferred (realized) part of the period"),
	operationPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }).describe("The person operation period; its start is driftstart, the earliest allowed membership end date")
});

/** Responsible: NCA, Updated: 20260628 */
export class PersonGroupMembershipChangeInfo {
	constructor(
		/** The person this info concerns */
		public personId: number,
		/** True if removing/shortening over the period leaves the person without any person-group membership under the unit (would trigger the invariant) */
		public onlyMembership: boolean,
		/** True if removing this membership over the period orphans function assignments (not covered by another membership) */
		public functionPlanned: boolean,
		/** True if any orphaned function falls in a salary-transferred (realized) part of the period */
		public payrollTransferred: boolean,
		/** The person operation period; its start is driftstart, the earliest allowed membership end date */
		public operationPeriod: DomainWsIntervalType,
	) {}
}

/**
	Necessary settings before login, e.g. useDate, logonMethod and OpenID configuration
	Responsible: AGRU, Updated: 20240522
*/
export class GetGlobalSettings extends WebRequest<GlobalSettings> {
	public readonly webService = "common";
	public readonly method = "GetGlobalSettings";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): GetGlobalSettings => {
        return new GetGlobalSettings();
          }
	public static readonly returnSchema = z.lazy(() => globalSettingsSchema);
	public resultFromJSON(json: WebResponseResult<GlobalSettings>): GlobalSettings {
		return validate(GetGlobalSettings.returnSchema, json) as unknown as GlobalSettings;
	}
}

/**
	Returns the orgunit with the unitid if the orgunit can be found
	Responsible: AW, Updated: 20260706
*/
export class FindOrgunit extends WebRequest<WsRefOrgunit> {
	public readonly webService = "common";
	public readonly method = "FindOrgunit";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public orgunit: WsRefOrgunit,
	) {
		super();
	}

	public static readonly create = (x: {orgunit: WsRefOrgunit}): FindOrgunit => {
        return new FindOrgunit(x.orgunit);
          }
	public static readonly returnSchema = z.lazy(() => wsRefOrgunitSchema);
	public resultFromJSON(json: WebResponseResult<WsRefOrgunit>): WsRefOrgunit {
		return validate(FindOrgunit.returnSchema, json) as unknown as WsRefOrgunit;
	}
}

/**
	Returns the person with the personid if the person can be found
	Responsible: AW, Updated: 20260703
*/
export class FindPerson extends WebRequest<WsRefPerson> {
	public readonly webService = "common";
	public readonly method = "FindPerson";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public person: WsRefPerson,
	) {
		super();
	}

	public static readonly create = (x: {person: WsRefPerson}): FindPerson => {
        return new FindPerson(x.person);
          }
	public static readonly returnSchema = z.lazy(() => wsRefPersonSchema);
	public resultFromJSON(json: WebResponseResult<WsRefPerson>): WsRefPerson {
		return validate(FindPerson.returnSchema, json) as unknown as WsRefPerson;
	}
}

/**
	Returns the shifttype with the shifttypeId if the shifttype can be found
	Responsible: AW, Updated: 20260706
*/
export class FindShifttype extends WebRequest<WsRefShifttype> {
	public readonly webService = "common";
	public readonly method = "FindShifttype";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shifttype: WsRefShifttype,
	) {
		super();
	}

	public static readonly create = (x: {shifttype: WsRefShifttype}): FindShifttype => {
        return new FindShifttype(x.shifttype);
          }
	public static readonly returnSchema = z.lazy(() => wsRefShifttypeSchema);
	public resultFromJSON(json: WebResponseResult<WsRefShifttype>): WsRefShifttype {
		return validate(FindShifttype.returnSchema, json) as unknown as WsRefShifttype;
	}
}

/**
	Returns the shiftCounter with the counterid if the shiftCounter can be found
	Responsible: AW, Updated: 20260706
*/
export class FindShiftCounter extends WebRequest<WsRefShiftCounter> {
	public readonly webService = "common";
	public readonly method = "FindShiftCounter";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftCounter: WsRefShiftCounter,
	) {
		super();
	}

	public static readonly create = (x: {shiftCounter: WsRefShiftCounter}): FindShiftCounter => {
        return new FindShiftCounter(x.shiftCounter);
          }
	public static readonly returnSchema = z.lazy(() => wsRefShiftCounterSchema);
	public resultFromJSON(json: WebResponseResult<WsRefShiftCounter>): WsRefShiftCounter {
		return validate(FindShiftCounter.returnSchema, json) as unknown as WsRefShiftCounter;
	}
}

/**
	Returns the ShiftDef with the ShiftDefId if the ShiftDef can be found
	Responsible: AW, Updated: 20260706
*/
export class FindShiftDef extends WebRequest<WsRefShiftDef> {
	public readonly webService = "common";
	public readonly method = "FindShiftDef";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftdef: WsRefShiftDef,
	) {
		super();
	}

	public static readonly create = (x: {shiftdef: WsRefShiftDef}): FindShiftDef => {
        return new FindShiftDef(x.shiftdef);
          }
	public static readonly returnSchema = z.lazy(() => wsRefShiftDefSchema);
	public resultFromJSON(json: WebResponseResult<WsRefShiftDef>): WsRefShiftDef {
		return validate(FindShiftDef.returnSchema, json) as unknown as WsRefShiftDef;
	}
}

/**
	Returns the TaskDef with the TaskDef id if the TaskDef can be found
	Responsible: AW, Updated: 20260706
*/
export class FindTaskDef extends WebRequest<WsRefTaskDef> {
	public readonly webService = "common";
	public readonly method = "FindTaskDef";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public taskdef: WsRefTaskDef,
	) {
		super();
	}

	public static readonly create = (x: {taskdef: WsRefTaskDef}): FindTaskDef => {
        return new FindTaskDef(x.taskdef);
          }
	public static readonly returnSchema = z.lazy(() => wsRefTaskDefSchema);
	public resultFromJSON(json: WebResponseResult<WsRefTaskDef>): WsRefTaskDef {
		return validate(FindTaskDef.returnSchema, json) as unknown as WsRefTaskDef;
	}
}

/**
	Returns the Task with the Task id if the Task can be found
	Responsible: AW, Updated: 20260706
*/
export class FindTask extends WebRequest<WsRefTask> {
	public readonly webService = "common";
	public readonly method = "FindTask";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public task: WsRefTask,
	) {
		super();
	}

	public static readonly create = (x: {task: WsRefTask}): FindTask => {
        return new FindTask(x.task);
          }
	public static readonly returnSchema = z.lazy(() => wsRefTaskSchema);
	public resultFromJSON(json: WebResponseResult<WsRefTask>): WsRefTask {
		return validate(FindTask.returnSchema, json) as unknown as WsRefTask;
	}
}

/**
	Returns the Account with the wsRefAccount if the account can be found
	Responsible: AW, Updated: 20260706
*/
export class FindAccount extends WebRequest<WsRefAccount> {
	public readonly webService = "common";
	public readonly method = "FindAccount";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public account: WsRefAccount,
	) {
		super();
	}

	public static readonly create = (x: {account: WsRefAccount}): FindAccount => {
        return new FindAccount(x.account);
          }
	public static readonly returnSchema = z.lazy(() => wsRefAccountSchema);
	public resultFromJSON(json: WebResponseResult<WsRefAccount>): WsRefAccount {
		return validate(FindAccount.returnSchema, json) as unknown as WsRefAccount;
	}
}

/**
	Returns the project with the wsRefProject if the project can be found
	Responsible: AW, Updated: 20260706
*/
export class FindProject extends WebRequest<WsRefProject> {
	public readonly webService = "common";
	public readonly method = "FindProject";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public project: WsRefProject,
	) {
		super();
	}

	public static readonly create = (x: {project: WsRefProject}): FindProject => {
        return new FindProject(x.project);
          }
	public static readonly returnSchema = z.lazy(() => wsRefProjectSchema);
	public resultFromJSON(json: WebResponseResult<WsRefProject>): WsRefProject {
		return validate(FindProject.returnSchema, json) as unknown as WsRefProject;
	}
}

/**
	Returns the DimensionItem with the wsRefDimensionItem if the DimensionItem  can be found
	Responsible: AW, Updated: 20260706
*/
export class FindDimensionItem extends WebRequest<WsRefDimensionItem> {
	public readonly webService = "common";
	public readonly method = "FindDimensionItem";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public dimensionItem: WsRefDimensionItem,
	) {
		super();
	}

	public static readonly create = (x: {dimensionItem: WsRefDimensionItem}): FindDimensionItem => {
        return new FindDimensionItem(x.dimensionItem);
          }
	public static readonly returnSchema = z.lazy(() => wsRefDimensionItemSchema);
	public resultFromJSON(json: WebResponseResult<WsRefDimensionItem>): WsRefDimensionItem {
		return validate(FindDimensionItem.returnSchema, json) as unknown as WsRefDimensionItem;
	}
}

/** Responsible: TAJ, Updated: 20260526 */
export class RemovePersonsFromPersonGroup extends WebRequest<boolean> {
	public readonly webService = "common";
	public readonly method = "RemovePersonsFromPersonGroup";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public personGroupId: string,
		public personIdList: number[],
		public validity: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {personGroupId: string, personIdList: number[], validity: DomainWsIntervalType}): RemovePersonsFromPersonGroup => {
        return new RemovePersonsFromPersonGroup(x.personGroupId, x.personIdList, x.validity);
          }
	public static readonly returnSchema = z.boolean();
	public resultFromJSON(json: WebResponseResult<boolean>): boolean {
		return validate(RemovePersonsFromPersonGroup.returnSchema, json) as unknown as boolean;
	}
}

export const GetGlobalSettingsAI = { key: 'common_GetGlobalSettings' as const,
          webService: 'common' as const,
           method: 'GetGlobalSettings' as const,
           description: "Necessary settings before login, e.g. useDate, logonMethod and OpenID configuration",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.lazy(() => globalSettingsJsonSchema),
          outputSchema: z.lazy(() => globalSettingsSchema),
          requestClass: GetGlobalSettings
          }
export const FindOrgunitAI = { key: 'common_FindOrgunit' as const,
          webService: 'common' as const,
           method: 'FindOrgunit' as const,
           description: "Returns the orgunit with the unitid if the orgunit can be found",
           inputJsonSchema: z.object({ orgunit: z.lazy(() => wsRefOrgunitJsonSchema)}),
           inputSchema: z.object({ orgunit: z.lazy(() => wsRefOrgunitSchema)}),
          outputJsonSchema: z.lazy(() => wsRefOrgunitJsonSchema),
          outputSchema: z.lazy(() => wsRefOrgunitSchema),
          requestClass: FindOrgunit
          }
export const FindPersonAI = { key: 'common_FindPerson' as const,
          webService: 'common' as const,
           method: 'FindPerson' as const,
           description: "Returns the person with the personid if the person can be found",
           inputJsonSchema: z.object({ person: z.lazy(() => wsRefPersonJsonSchema)}),
           inputSchema: z.object({ person: z.lazy(() => wsRefPersonSchema)}),
          outputJsonSchema: z.lazy(() => wsRefPersonJsonSchema),
          outputSchema: z.lazy(() => wsRefPersonSchema),
          requestClass: FindPerson
          }
export const FindShifttypeAI = { key: 'common_FindShifttype' as const,
          webService: 'common' as const,
           method: 'FindShifttype' as const,
           description: "Returns the shifttype with the shifttypeId if the shifttype can be found",
           inputJsonSchema: z.object({ shifttype: z.lazy(() => wsRefShifttypeJsonSchema)}),
           inputSchema: z.object({ shifttype: z.lazy(() => wsRefShifttypeSchema)}),
          outputJsonSchema: z.lazy(() => wsRefShifttypeJsonSchema),
          outputSchema: z.lazy(() => wsRefShifttypeSchema),
          requestClass: FindShifttype
          }
export const FindShiftCounterAI = { key: 'common_FindShiftCounter' as const,
          webService: 'common' as const,
           method: 'FindShiftCounter' as const,
           description: "Returns the shiftCounter with the counterid if the shiftCounter can be found",
           inputJsonSchema: z.object({ shiftCounter: z.lazy(() => wsRefShiftCounterJsonSchema)}),
           inputSchema: z.object({ shiftCounter: z.lazy(() => wsRefShiftCounterSchema)}),
          outputJsonSchema: z.lazy(() => wsRefShiftCounterJsonSchema),
          outputSchema: z.lazy(() => wsRefShiftCounterSchema),
          requestClass: FindShiftCounter
          }
export const FindShiftDefAI = { key: 'common_FindShiftDef' as const,
          webService: 'common' as const,
           method: 'FindShiftDef' as const,
           description: "Returns the ShiftDef with the ShiftDefId if the ShiftDef can be found",
           inputJsonSchema: z.object({ shiftdef: z.lazy(() => wsRefShiftDefJsonSchema)}),
           inputSchema: z.object({ shiftdef: z.lazy(() => wsRefShiftDefSchema)}),
          outputJsonSchema: z.lazy(() => wsRefShiftDefJsonSchema),
          outputSchema: z.lazy(() => wsRefShiftDefSchema),
          requestClass: FindShiftDef
          }
export const FindTaskDefAI = { key: 'common_FindTaskDef' as const,
          webService: 'common' as const,
           method: 'FindTaskDef' as const,
           description: "Returns the TaskDef with the TaskDef id if the TaskDef can be found",
           inputJsonSchema: z.object({ taskdef: z.lazy(() => wsRefTaskDefJsonSchema)}),
           inputSchema: z.object({ taskdef: z.lazy(() => wsRefTaskDefSchema)}),
          outputJsonSchema: z.lazy(() => wsRefTaskDefJsonSchema),
          outputSchema: z.lazy(() => wsRefTaskDefSchema),
          requestClass: FindTaskDef
          }
export const FindTaskAI = { key: 'common_FindTask' as const,
          webService: 'common' as const,
           method: 'FindTask' as const,
           description: "Returns the Task with the Task id if the Task can be found",
           inputJsonSchema: z.object({ task: z.lazy(() => wsRefTaskJsonSchema)}),
           inputSchema: z.object({ task: z.lazy(() => wsRefTaskSchema)}),
          outputJsonSchema: z.lazy(() => wsRefTaskJsonSchema),
          outputSchema: z.lazy(() => wsRefTaskSchema),
          requestClass: FindTask
          }
export const FindAccountAI = { key: 'common_FindAccount' as const,
          webService: 'common' as const,
           method: 'FindAccount' as const,
           description: "Returns the Account with the wsRefAccount if the account can be found",
           inputJsonSchema: z.object({ account: z.lazy(() => wsRefAccountJsonSchema)}),
           inputSchema: z.object({ account: z.lazy(() => wsRefAccountSchema)}),
          outputJsonSchema: z.lazy(() => wsRefAccountJsonSchema),
          outputSchema: z.lazy(() => wsRefAccountSchema),
          requestClass: FindAccount
          }
export const FindProjectAI = { key: 'common_FindProject' as const,
          webService: 'common' as const,
           method: 'FindProject' as const,
           description: "Returns the project with the wsRefProject if the project can be found",
           inputJsonSchema: z.object({ project: z.lazy(() => wsRefProjectJsonSchema)}),
           inputSchema: z.object({ project: z.lazy(() => wsRefProjectSchema)}),
          outputJsonSchema: z.lazy(() => wsRefProjectJsonSchema),
          outputSchema: z.lazy(() => wsRefProjectSchema),
          requestClass: FindProject
          }
export const FindDimensionItemAI = { key: 'common_FindDimensionItem' as const,
          webService: 'common' as const,
           method: 'FindDimensionItem' as const,
           description: "Returns the DimensionItem with the wsRefDimensionItem if the DimensionItem  can be found",
           inputJsonSchema: z.object({ dimensionItem: z.lazy(() => wsRefDimensionItemJsonSchema)}),
           inputSchema: z.object({ dimensionItem: z.lazy(() => wsRefDimensionItemSchema)}),
          outputJsonSchema: z.lazy(() => wsRefDimensionItemJsonSchema),
          outputSchema: z.lazy(() => wsRefDimensionItemSchema),
          requestClass: FindDimensionItem
          }
export const RemovePersonsFromPersonGroupAI = { key: 'common_RemovePersonsFromPersonGroup' as const,
          webService: 'common' as const,
           method: 'RemovePersonsFromPersonGroup' as const,
           description: "",
           inputJsonSchema: z.object({ personGroupId: z.string(), personIdList: z.array(z.int()), validity: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ personGroupId: z.string(), personIdList: z.array(z.int()), validity: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.boolean(),
          outputSchema: z.boolean(),
          requestClass: RemovePersonsFromPersonGroup
          }
export const endpoints = [GetGlobalSettingsAI, FindOrgunitAI, FindPersonAI, FindShifttypeAI, FindShiftCounterAI, FindShiftDefAI, FindTaskDefAI, FindTaskAI, FindAccountAI, FindProjectAI, FindDimensionItemAI, RemovePersonsFromPersonGroupAI] as const;
export type Endpoint = (typeof endpoints)[number];
